import React from 'react'
import PropTypes from 'prop-types'

import useDropdown from '../DropDown'
import { Menu } from '../DropDown.styles'
import { NavButton, ProjectsNavWrapper } from './Navigation.styles'

const ProjectsNav = ({ content, lang, activeProject, dispatch }) => {
  const {
    activeItem,
    menuItems,
    setSelected,
    opened,
    ...projectsDropDown
  } = useDropdown({
    active: (activeProject && activeProject.id) || null,
    items: content,
    callback: opened => {
      dispatch({
        type: 'setActiveNav',
        payload: opened ? 'project-nav' : null
      })
    }
  })

  function onClick({ id, position }) {
    setSelected(id)
    dispatch({
      type: 'setActiveNav',
      payload: null
    })
    dispatch({
      type: 'updateActiveProject',
      payload: {
        id,
        position
      }
    })
  }

  return (
    <ProjectsNavWrapper>
      {projectsDropDown.renderToggleButton({
        label: activeItem ? activeItem.title[lang] : 'select'
      })}
      <Menu opened={opened}>
        {menuItems.map(item => (
          <NavButton onClick={() => onClick(item)} key={item.id}>
            {item.title[lang]}
          </NavButton>
        ))}
      </Menu>
    </ProjectsNavWrapper>
  )
}

ProjectsNav.propTypes = {
  activeProject: PropTypes.object,
  dispatch: PropTypes.func,
  content: PropTypes.array,
  lang: PropTypes.string
}

export default ProjectsNav
